module.exports = ()->
  return {
    template: require('./search-result-preview.html')
    controller: ( $scope ) ->

      $scope.isUrlLinksToWeb = ( result ) ->
        result.isFactivaResult() or result.isPepDeskResult()

      isTitleLinksToWeb = ( result ) ->
        return result.hasUrl() and not $scope.isUrlLinksToWeb( result )

      $scope.getTitleLink = ( result ) ->
        if isTitleLinksToWeb( result )
          return result.url
        else
          return result.get_absolute_url

      $scope.getTranslatedTitleLink = ( result ) ->
        if isTitleLinksToWeb( result )
          return result.url
        else
          return result.translated_url
  }
